import { render } from "./ReportProblem.vue?vue&type=template&id=01232770&scoped=true"
const script = {}

import "./ReportProblem.vue?vue&type=style&index=0&id=01232770&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Raska\\Desktop\\raska\\projekat\\astra\\astra-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01232770"]])

export default __exports__